import React, { useState, useEffect, useRef } from 'react';
import { useAppSelector } from '../store/hooks';
import { get } from '../api/apiService';
import { apiEndPoints } from '../api/apiEndPoints';
import { useTheme } from '../theming/default_theme';
import './FilterHospitalSideBar.css'; // Import your custom styles


const FilterHospitalSidebar: React.FC<{
  setShowFilter: (show: boolean) => void;
  showFilter: (boolean); hospitalList: Array<any>;
  allHospitals: Array<{}>;
  setAllHospitals: (hospitals: Array<{}>) => void;
  selectedCities: string[];
  setSelectedCities: React.Dispatch<React.SetStateAction<string[]>>; // Correct type for setState
  selectedServices: string[];
  setSelectedServices: React.Dispatch<React.SetStateAction<string[]>>; // Correct type for setState
  setIsFilterApplyClicked: React.Dispatch<React.SetStateAction<boolean>>;
}
> = ({ setShowFilter, showFilter, hospitalList, allHospitals, setAllHospitals, selectedCities, setSelectedCities, selectedServices, setSelectedServices, setIsFilterApplyClicked }) => {

  const theme = useTheme();
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedState, setSelectedState] = useState('');

  const [hospitalsCityList, setHospitalsCityList] = useState<string[]>([]);
  const [hospitalsStateList, setHospitalsStateList] = useState<string[]>([]);
  const [hospitalsServiceList, setHospitalsServiceList] = useState<string[]>([]);
  const [displayCityList, setDisplayCityList] = useState(false);
  const [displayServiceList, setDisplayServiceList] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [citiesStates, setCitiesStates] = React.useState<any[]>([]);
  const citiesStatesRef = useRef<{ state: string; cities: string[] }[] | ''>('');
  const hospitalsServiceRef = useRef<string | string[]>('');
  const citiesStateList: { state: string, cities: string[] }[] = [];
  const [citySearchText, setCitySearchText] = useState('');

  let responseCityList: string[] = [];
  let responseStateList: string[] = [];
  let responseServicesList: string[] = [];

  interface HospitalData {
    city: string;
    state: string;
    service: string;
  };



  useEffect(() => {
    setIsFilterApplyClicked(false);
    const fetchHospitalCityStateServicesData = async () => {
      // if (!showModal) {
      try {
        const response = await fetchAllHospitalData();
        console.log('Data:', response);
        console.log('address--', response[0].address);


        console.log('allHospitals--', allHospitals);
        if (response && response.length > 0) {
          response.forEach((hospital: Record<string, any>) => {
            responseStateList.push(hospital.address.state);
            responseCityList.push(hospital.address.city, hospital.address.state);
            responseServicesList.push(hospital.services);
          });
          console.log('responseCityList--', responseCityList);
          console.log('responseServicesList--', responseServicesList);
          responseStateList = responseStateList.filter((value, index, self) => self.indexOf(value) === index);
          responseServicesList = responseServicesList.filter((value, index, self) => self.indexOf(value) === index);
          const allServices: string = responseServicesList.reduce((longest, current) => {
            return current.length > longest.length ? current : longest;
          }, "");

          console.log('allServices--', allServices);
          hospitalsServiceRef.current = allServices;
          console.log('hospitalsServiceRef--', hospitalsServiceRef.current);

        };

        console.log('responseStateList--', responseStateList);
        console.log(responseServicesList);
        responseStateList.map(state => {
          const cityState: { state: string, cities: string[] } = { state: '', cities: [] };
          const cities = response.filter((hospital: Record<string, any>) => hospital.address.state.includes(state))
            .map((hospital: Record<string, any>) => hospital.address.city).filter((value: string, index: number, self: string[]) =>
              self.findIndex(v => v.toLowerCase() === value.toLowerCase()) === index
            )
            .map((str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase());

          console.log('cities--', cities);
          cityState.state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
          cityState.cities = cities;
          console.log('cityState--', cityState);

          if (!citiesStateList.some((item) => item.state === cityState.state)) {
            citiesStateList.push(cityState);
          }


        });
        console.log('citiesStateList--', citiesStateList);
        citiesStatesRef.current = citiesStateList;
        console.log('citiesStatesRef--', citiesStatesRef.current);
      }
      catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchHospitalCityStateServicesData();
  }, []);



  const handleCityClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, value } = event.target;

    setSelectedCities((prevSelectedCities: string[]) =>
      checked
        ? [...prevSelectedCities, value] // Add city if checked
        : prevSelectedCities.filter((city: string) => city !== value) // Remove city if unchecked
    );
    console.log('Selected Cities:', selectedCities);
  };

  function handleServiceClick(event: React.ChangeEvent<HTMLInputElement>): void {
    const { checked, value } = event.target;

    setSelectedServices((prevSelectedServices: string[]) =>
      checked
        ? [...prevSelectedServices, value] // Add city if checked
        : prevSelectedServices.filter((services) => services !== value) // Remove city if unchecked
    );
    console.log('Selected Services:', selectedServices);
  }

  const fetchAllHospitalData = async () => {
    try {
      setLoading(true);
      const url = apiEndPoints.hospitalsEndPoint;
      const response = await get(url);
      console.log('API Response:', response);
      setLoading(false);
      return response;
    } catch (err) {

      // setLoading(false);
    }
  };

  const onClose = () => {
    setShowFilter(false);

  }


  const handleSearchTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCitySearchText(event.target.value);
  };

  const allCities: string[] = React.useMemo(() => {
    if (!citiesStatesRef.current || !Array.isArray(citiesStatesRef.current)) return [];
    return citiesStatesRef.current.flatMap(cs => cs.cities);
  }, [citiesStatesRef.current]);

  const areAllCitiesSelected = allCities.length > 0 && allCities.every(city => selectedCities.includes(city));

  const handleSelectAllCities = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelectedCities(allCities);
    } else {
      setSelectedCities([]);
    }
  };

  return (
    <div
      className={`absolute top-[0px] right-0 w-[25%] text-sm bg-white border-2 border-[#C0C4D6] rounded-[16px] shadow-lg transform transition-transform duration-300 ease-in-out`}
      style={{ height: 'auto', maxHeight: '100vh', overflowY: 'auto' }}
    >
      <div className="flex items-center justify-between p-2 px-3 border-b bg-[#F9F7ED]" style={{ backgroundColor: "#F9F7ED" }}>
        <h2 className="text-sm font-semibold">Filter By</h2>
        <img
          src="/close.png"
          alt="Close"
          className="w-4 h-4 cursor-pointer ml-auto"
          onClick={onClose}
        />
      </div>

      <div className="p-2 flex flex-col gap-3 overflow-y-auto h-full">
        {/* City Dropdown */}
        <div>
          <label className="block text-xs font-regular mb-1">City</label>
          {true ? (
            <div className="flex flex-col">
              <div
                className={`flex w-45 h-8 border border-[#40559C] rounded-full overflow-hidden items-center cursor-pointer p-2 text-xs text-[#40559C] mb-1`}
                onClick={() => setDisplayCityList(!displayCityList)}
              >
                Select city
                <img src={`${displayCityList ? '/up-arrow.png' : '/down-arrow.png'}`} alt="down-up-arrow" className="w-3 h-3 ml-auto" />
              </div>
              {displayCityList && (
                <div className="flex flex-col mt-1 ml-1 border border-gray-300 rounded p-1 rounded-lg overflow-hidden max-h-60">
                  <div className="relative flex flex-row ml-1 items-center text-center gap-2">
                    <img
                      src="/search.png"
                      alt="search"
                      className="relative left-1 w-3 h-3 pointer-events-none mr-1"
                    // style={{ top: '50%', transform: 'translateY(-50%)' }}
                    />
                    <input
                      type="text"
                      placeholder="Search city"
                      className="flex flex-row h-6 text-[#8B91A6] placeholder:text-xs border-none focus:outline-none focus:ring-0 items-center justify-center text-xs "
                      onChange={handleSearchTextChange}
                    />
                  </div>

                  <div
                    className={`flex flex-col w-[95%] items-start border border-[[#40559C]] rounded-lg overflow-y-auto ml-2 mb-1`}
                    style={{ maxHeight: '150px' }} // You can adjust 200px as needed
                  >
                    <div className="flex flex-row w-full items-center bg-[#E2EBF7] text-xs p-2 px-4 rounded-t-lg gap-x-2">
                      <input
                        type="checkbox"
                        checked={areAllCitiesSelected}
                        onChange={handleSelectAllCities}
                        id="selectAllCities"
                        className="custom-accent"
                      />
                      <label htmlFor="selectAllCities">Select all cities</label>
                    </div>
                    {citiesStatesRef.current && citiesStatesRef.current.map((cityState) => {
                      const filteredCities = cityState.cities.filter((city: string) =>
                        city.toLowerCase().includes(citySearchText.toLowerCase())
                      );
                      if (filteredCities.length === 0) return null;
                      return (
                        <div key={cityState.state} className="flex flex-col w-full text-xs">
                          <div className="font-bold text-xs mb-1 px-4 w-full">{cityState.state}</div>
                          {filteredCities.map((city: string) => (
                            <label key={city} htmlFor={city} className={`${selectedCities.includes(city) ? 'bg-[#E2EBF7]' : ''} flex w-full items-center  px-4 py-1 text-xs gap-x-2`}>
                              <input
                                type="checkbox"
                                id={city}
                                name={city}
                                value={city}
                                onChange={handleCityClick}
                                checked={selectedCities.includes(city)}
                                className="custom-accent"
                              />
                              {city}
                            </label>
                          ))}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>

        {/* Service Dropdown */}
        {sessionStorage.getItem('menuSelected') === 'Hospitals' && <div className="flex flex-col text-xs">
          <label className="block text-xs font-regular mb-1">Service</label>
          <div
            className={`flex w-45 h-8 border border-[#40559C] rounded-full overflow-hidden items-center cursor-pointer p-2 text-xs text-[#40559C] mb-1`}
            onClick={() => setDisplayServiceList(!displayServiceList)}
          >
            Select service
            <img src={`${displayServiceList ? '/up-arrow.png' : '/down-arrow.png'}`} alt="down-up-arrow" className="w-3 h-3 ml-auto" />
          </div>
          {displayServiceList && <div className="flex flex-col mt-1 pl-2 border border-gray-300 rounded p-1 rounded-lg overflow-y-auto max-h-96 text-center text-xs">
            {Array.isArray(hospitalsServiceRef.current) && hospitalsServiceRef.current.map((service) => (
              <div key={service} className="flex flex-row gap-x-1 items-center text-center mt-1 mb-1 text-xs">
                <input
                  type="checkbox"
                  id={service}
                  name={service}
                  value={service}
                  onChange={handleServiceClick} // Attach the event handler here
                  checked={selectedServices.includes(service)} // Check if the city is in the selectedCities array
                  className="custom-accent"
                />
                <label htmlFor={service}>{service}</label>
              </div>

            ))}
          </div>}

        </div>}

        {/* Apply Button */}
        <div className="flex flex-row mr-10 mb-2 gap-x-3">
          <button
            className="inline-flex bg-[#102A83] text-white py-1 px-4 rounded-full text-xs justify-center items-center"
            onClick={() => {
              setIsFilterApplyClicked(true);
              onClose();
            }}
          >
            Apply
          </button>
          <button
            className="inline-flex bg-white text-[#FF0000] py-1 px-4 border border-[#FF0000] rounded-full text-xs justify-center items-center whitespace-nowrap"
            onClick={() => {
              setSelectedCities([]);
              setSelectedServices([]);
              setIsFilterApplyClicked(prev => !prev);
              onClose();
            }}
          >
            Clear Filter
          </button>
        </div>
      </div>
    </div>
  );
};
export default FilterHospitalSidebar;